<template>
  <div class="lg:tw-w-[800px]">
    <WizardQuestion
      :title="
        getComponentUiText(
          'app-menu-submenu-home-setup-wizard-modal-services-title-1',
        )
      "
      :description="
        getComponentUiText(
          'app-menu-submenu-home-setup-wizard-modal-services-description-1',
        )
      "
      :has-why="false"
      :custom-padding-x="'25px'"
    >
      <WizardMultiLevelMultiSelectQuestion
        v-if="serviceSubTypeDropdown && serviceSubTypeDropdown.length"
        :title="
          getComponentUiText(
            'app-menu-submenu-home-setup-wizard-modal-services-question-1',
          )
        "
        :required="false"
        :dropdown-data="serviceSubTypeDropdown"
        :placeholder="
          getComponentUiText(
            'app-menu-submenu-home-setup-wizard-modal-select-services-1',
          )
        "
        :search-placeholder="
          getComponentUiText(
            'app-menu-submenu-home-setup-wizard-modal-services-question-placeholder-1',
          )
        "
        :time-updated="timeUpdated"
        @update:model-value="updateServiceType"
      />
      <div
        v-if="
          statusInPage.statusPage === statusPage.Error &&
          statusInPage.errorMessage
        "
        class="tw-bg-[#FEE5E2] tw-px-[12px] tw-py-[8px] tw-flex tw-items-center tw-mt-[37px] tw-rounded-[6px] tw-gap-[10px]"
      >
        <WarningIcon color="#F7553C" />
        <p
          class="tw-text-[#F7553C] tw-text-[11px] tw-font-[500] tw-leading-[130%] tw-text-center tw-mb-[0px]"
        >
          {{
            getComponentUiText(
              "app-component-wizards-setup-error-tooltip",
              false,
              {
                errorMessage: statusInPage.errorMessage
                  ? ensurePeriod(statusInPage.errorMessage)
                  : "",
              },
            )
          }}
        </p>
      </div>
      <p
        v-if="servicesAnswers && servicesAnswers.length > 0"
        class="tw-mb-[25px] tw-pt-[37px] tw-leading-[100%]"
      >
        <span class="tw-text-[#231F20] tw-text-[14px] tw-font-medium">{{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-service-note-1",
          )
        }}</span>
      </p>
      <div v-if="servicesAnswers && servicesAnswers.length > 0">
        <div
          v-for="(groupService, indexGroup) in servicesAnswers"
          :key="indexGroup"
        >
          <div
            v-for="(item, index) in groupService"
            :key="`${item?.idUpdate || item.id}`"
            class="tw-mb-[10px]"
          >
            <ListService
              ref="listServicesRef"
              :index="index"
              :item-first="item"
              :current-index="index"
              :group-index="indexGroup"
              :status-in-page="statusInPage"
              :question-section-value="questionSectionValue"
              :current-org="currentOrg.id"
              @update:service="
                (data) => {
                  servicesAnswers[indexGroup][index].orgServices =
                    data?.orgServices;
                  servicesAnswers[indexGroup][index] = {
                    ...data,
                  };
                }
              "
            />
          </div>

          <b-button
            v-if="groupService && groupService.length > 0"
            variant=""
            :class="`button-add-another tw-mb-[25px]  tw-bg-[#fff] tw-py-[15px] tw-px-[25px] tw-rounded-md tw-w-full`"
            style="
              border-radius: 6px;
              border: 1px solid var(--UI-rule, #eff0f1);
            "
            @click="addService(groupService[0] || {}, indexGroup)"
          >
            <div :class="['tw-flex tw-justify-between tw-items-center']">
              <span
                :class="['tw-text-[#211F58] tw-text-[14px] tw-font-semibold']"
              >
                {{
                  getComponentUiText(
                    "app-menu-submenu-home-setup-wizard-add-another-button-1",
                  )
                }}
                <span v-if="groupService[0]?.parentTitle">
                  {{ groupService[0]?.parentTitle }}:
                  <span style="font-weight: 400"
                    >{{ groupService[0]?.title }}
                  </span>
                </span>
                <span v-else>{{ groupService[0].title }}</span>
              </span>

              <div
                class="tw-flex tw-items-center tw-justify-center tw-w-[28px] tw-h-[28px] tw-min-w-[28px] tw-min-h-[28px] tw-bg-[#387DFF] tw-rounded-[50%]"
              >
                <span
                  class="tw-text-[#fff] tw-text-base tw-font-medium tw-mt-[2px]"
                  >+</span
                >
              </div>
            </div>
          </b-button>
        </div>
      </div>
    </WizardQuestion>
  </div>
</template>

<script setup lang="ts">
import Utils, { ensurePeriod, getComponentUiText } from "@/utils/utilities";
import WizardQuestion from "./wizardQuestion.vue";
import store from "@/store";
import { ComputedRef, computed, onBeforeUnmount, ref } from "vue";
import ListService from "./listService.vue";
import WizardMultiLevelMultiSelectQuestion from "./wizardMultiLevelMultiSelectQuestion.vue";
import {
  statusPage,
  WIZARD_STATE_NAME,
  WIZARD_STATE_PAGE,
} from "@/utils/constants";
import {
  IWizardQuestion,
  IWizardServicesValue,
  IWizardTypeValue,
} from "@/interfaces/wizard";
import { Ref } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";
import { onMounted } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import dayjs from "dayjs";
import WarningIcon from "../svgs/warningIcon.vue";

defineProps({
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});

const emit = defineEmits(["change:add:service"]);

const listServicesRef: any = ref([]);
const timeUpdated: any = ref(`${dayjs().unix()}`);

const currentOrg = computed(() => store.state.Org.currentOrg);
const originServices: ComputedRef<IWizardServicesValue[]> = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.values;
});
let servicesAnswers: ComputedRef<IWizardServicesValue[][]> = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.formatData;
});

const listServiceType = computed(() => {
  return store.state.SetupWizard.questions[currentOrg.value.id]?.services[0]
    ?.types;
});

const serviceSubTypeDropdown: Ref<IMultiSelectDropdown[]> = ref([]);
let listServiceSubType: IWizardTypeValue[] = [];

onMounted(() => {
  if (
    Array.isArray(listServiceType.value) &&
    listServiceType.value.length > 0
  ) {
    listServiceSubType = listServiceType?.value[1].typeValues ?? [];
    serviceSubTypeDropdown.value = generateServiceSubtypeDropdown(
      originServices.value || [],
    );
  }
  EventEmitter.on(EmitterEvents.SERVICE_DELETE_ITEM, (data: any) => {
    if (servicesAnswers.value[data.indexGroup].length === 1) {
      //parentTitle
      const serviceSubTypeId =
        servicesAnswers.value[data.indexGroup][0].serviceSubTypeId;
      let indexServiceSubType, indexParentServiceSubType;
      if (!servicesAnswers.value[data.indexGroup][0].parentTitle) {
        indexServiceSubType = serviceSubTypeDropdown.value.findIndex(
          (i) =>
            i.id === servicesAnswers.value[data.indexGroup][0].serviceSubTypeId,
        );
        serviceSubTypeDropdown.value[indexServiceSubType].selected = false;
      } else {
        for (let i = 0; i < serviceSubTypeDropdown.value.length; i++) {
          const childData = serviceSubTypeDropdown.value[i].childData;
          if (childData && childData.length > 0) {
            const indexSubType = childData.findIndex(
              (j) =>
                j.id ===
                servicesAnswers.value[data.indexGroup][0].serviceSubTypeId,
            );
            if (indexSubType > -1) {
              indexParentServiceSubType = i;
              indexServiceSubType = indexSubType;
              break;
            }
          }
        }
        const childData =
          serviceSubTypeDropdown.value[indexParentServiceSubType].childData ||
          [];
        childData[indexServiceSubType].selected = false;
        serviceSubTypeDropdown.value[indexParentServiceSubType].childData =
          childData;
      }
      servicesAnswers.value.splice(data.indexGroup, 1);
      timeUpdated.value = `${dayjs().unix()}`;
    } else {
      servicesAnswers.value[data.indexGroup].splice(data.indexCurrent, 1);
    }
  });
  EventEmitter.on(EmitterEvents.SERVICE_UPDATE_ITEM, (data: any) => {
    const item = servicesAnswers.value[data.indexGroup][data.indexCurrent];
    servicesAnswers.value[data.indexGroup][data.indexCurrent] = {
      ...item,
      id: data.dataUpdate?.id,
      endDate: data.dataUpdate?.endDate,
      timeUpdated: `${dayjs().unix()}${item.indexUpdate}`,
    };
  });
});

onBeforeUnmount(() => {
  EventEmitter.off(EmitterEvents.SERVICE_DELETE_ITEM);
  EventEmitter.off(EmitterEvents.SERVICE_UPDATE_ITEM);
});

const checkAllValidations = async () => {
  let isAllValid = true,
    listServices = [] as any[];
  for (let index = 0; index < listServicesRef.value.length; index++) {
    const test = await listServicesRef.value[index].saveChanges();
    if (!test.isValid) {
      isAllValid = false;
    }
    listServices.push(test.finalValue);
  }
  return isAllValid;
};

const questionSectionValue: ComputedRef<IWizardQuestion[]> = computed(() =>
  store.getters["SetupWizard/getQuestionsBySection"](
    WIZARD_STATE_NAME.SERVICES,
    currentOrg.value.id || null,
  ),
);

const updateServiceType = (value: any, data: Array<any>) => {
  if (!value) return;
  store.commit("SetupWizard/SET_IS_SELECTED_PAGE_WIZARD", {
    currentOrg: currentOrg.value.id,
    isSelected: true,
    namePage: WIZARD_STATE_PAGE.SERVICES,
    isSelectedPage: "isSelectedServices",
  });
  const index = servicesAnswers.value.findIndex(
    (i) => i[0].serviceSubTypeId === value,
  );
  if (index > -1) {
    onDeleteSubServiceType(index);
  } else {
    onAddSubServiceType(value);
  }
};

const onAddSubServiceType = (value) => {
  let indexGroup = servicesAnswers.value.findIndex(
    (i) => i[0].serviceSubTypeId === value,
  );
  let serviceData;
  if (indexGroup === -1) {
    const serviceSubType = listServiceSubType.find((i) => i.id === value);
    const title = serviceSubType?.name || "";
    let parentTitle = "";
    if (serviceSubType?.parentId) {
      const parentServiceSubType = listServiceSubType.find(
        (i) => i.id === serviceSubType.parentId,
      );
      parentTitle = `${parentServiceSubType?.name || ""}`;
    }
    const serviceTypeOptions = listServiceType.value[0].typeValues.filter(
      (i) => i.serviceSubTypeId === value,
    );
    serviceData = {
      serviceTypeOptions: serviceTypeOptions,
      serviceSubTypeId: value,
      parentTitle: parentTitle,
      title: title,
    };
  } else {
    serviceData = {
      serviceTypeOptions: servicesAnswers[indexGroup][0].serviceTypeOptions,
      serviceSubTypeId: servicesAnswers[indexGroup][0].serviceSubTypeId,
      parentTitle: servicesAnswers[indexGroup][0].parentTitle,
      title: servicesAnswers[indexGroup][0].title,
    };
  }
  addService(serviceData, indexGroup);
};

const onDeleteSubServiceType = (index) => {
  const serviceTypes = servicesAnswers.value[index].filter(
    (i) => i.id !== null,
  );
  for (let i = 0; i < serviceTypes.length; i++) {
    const value = {
      id: serviceTypes[i].id,
      isArchived: true,
      updated: true,
    };
    store.commit("SetupWizard/SET_VALUES_SERVICE_UPDATE", {
      value,
      indexUpdate: serviceTypes[i].indexUpdate,
      currentOrg: currentOrg.value.id,
    });
  }
  servicesAnswers.value.splice(index, 1);
};

const generateServiceSubtypeDropdown = (services: IWizardServicesValue[]) => {
  const serviceTypeSelected: string[] = [];
  if (services && services.length > 0) {
    services.forEach((i) => {
      if (!i?.isArchived) serviceTypeSelected.push(i.serviceTypeId || "");
    });
  }

  const serviceSubTypeSelected = serviceTypeSelected.map((i) =>
    getServiceSubTypeId(i),
  );

  // If have services => always have value "questionSectionValue".
  if (!questionSectionValue.value) return [];

  const subTypeConverted = Utils.convertDataFlatToTree(
    listServiceSubType as any[],
  );

  // Format list dropdown.
  return Object.values(subTypeConverted).map(
    (item: any) =>
      ({
        ...item,
        title: item?.name || "",
        selected: serviceSubTypeSelected.includes(item?.id),
        childData: item?.childData.map((child) => ({
          ...child,
          title: child.name,
          selected: serviceSubTypeSelected.includes(child?.id),
        })),
      }) as IMultiSelectDropdown,
  );
};

const getServiceSubTypeId = (serviceTypeId: string) => {
  const serviceTypes = listServiceType.value[0].typeValues;
  const serviceType = serviceTypes.find((i) => i.id === serviceTypeId);
  return serviceType?.serviceSubTypeId || "";
};

const generateSelectedItems = (items: IMultiSelectDropdown[]) => {
  return items.reduce((result: IMultiSelectDropdown[], item) => {
    if (item.selected) result.push({ ...item });

    if (item.childData) {
      const childItems = generateSelectedItems(item.childData);
      result.push(...childItems);
    }

    return result;
  }, []);
};
const addService = (serviceData, indexGroup) => {
  const newServiceType = {
    serviceTypeOptions: serviceData.serviceTypeOptions,
    serviceSubTypeId: serviceData.serviceSubTypeId,
    parentTitle: serviceData.parentTitle,
    title: serviceData.title,
    initServiceType: {},
    idUpdate: Math.random(),
  };
  if (indexGroup > -1) {
    servicesAnswers.value[indexGroup].push(newServiceType);
  } else {
    servicesAnswers.value.push([newServiceType]);
  }
};
defineExpose({
  checkAllValidations,
});
</script>

<style lang="scss" scoped>
.right-arrow-icon {
  margin-left: 10px;
  transition: transform 0.3s ease;
  transform: rotate(90deg) scale(1.2);

  &.show {
    transform: rotate(-90deg) scale(1.2);
  }
}

.more-detail-container {
  margin: 0;
  padding: 0;
  height: 0px;
  overflow: hidden;
  transition:
    height 0.3s ease,
    padding 0.3s ease;

  &.show {
    border-top: 1px solid #eff0f1;
    margin: 0px -25px -25px -25px;
    padding: 25px;
    height: auto;
    overflow: visible;
  }
}
</style>
